<template>
  <section id="kontakt">
    <h2 class="text-uppercase text-center">
      Kontakt
    </h2>
    <div class="row">
      <div class="col">
        <p class="text-center">
          Sie haben Fragen oder möchten einen Termin vereinbaren? Melden Sie sich gern!
        </p>
        <ul class="list-unstyled text-center">
          <li>
            <a
              href="mailto:mail@osteopathie-bruns.de"
            >
              <font-awesome-icon
                :icon="['fas', 'envelope']"
                class="mr-2"
              /> 
              mail@osteopathie-bruns.de</a>
          </li>
          <li>
            <a
              href="tel:+491797797077"
            >
              <font-awesome-icon
                :icon="['fas', 'phone-alt']"
                class="mr-2"
              /> 
              +49 179 7797077</a>
          </li>
          <li>
            <address>
              <span>
                <font-awesome-icon
                  :icon="['fas', 'home']"
                  class="mr-2"
                />
              </span>  Praxis Osteopathie Neukölln<br>
              Weichselstr. 37<br>
              12045 Berlin
            </address>
          </li>
        </ul>
        <hr class="invisible">
        <hr class="invisible">
        <hr class="invisible">
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col 12 col-md-6">
        <div class="map-wrapper">
          <iframe
            class="responsive-iframe"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://www.openstreetmap.org/export/embed.html?bbox=13.43681037425995%2C52.48793676837733%2C13.439256548881533%2C52.48916987249321&amp;layer=mapnik&amp;marker=52.48855332475669%2C13.43803346157074"
          />
        </div>
        <small><a
          href="https://www.openstreetmap.org/?mlat=52.48855&mlon=13.43770#map=19/52.48855/13.43770"
          target="_blank"
        >Größere Karte ansehen</a></small>
      </div>
    </div>
  </section>
</template>

<script>

export default {
    name: "ContentKontakt",
    mounted: function() {
      if(this.$route.path && this.$route.path == '/kontakt') {
        const element = document.getElementById(this.$route.path.substring(1));
        if(element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
}
</script>

<style scoped>
  .img-map {
    filter: grayscale(1);
  }
</style>
